module.exports = __webpack_public_path__ + "img/5614b44654f944914dfac4d566d04365.png";